import { CustomAccordion } from 'components/CustomAccordion/CustomAccordion'
import { useContractStore } from 'context/ContractStore'
import React, { memo, useEffect } from 'react'

const loanRequestData = data => {
  if (!data) return []

  return [
    { label: 'Кредитный продукт', value: data?.creditProduct?.name || 'Нет данных' },
    { label: 'Сумма займа', value: data?.loanAmount?.toString()?.thousandSeparator() || 'Нет данных' },
    { label: 'Валюта заявки', value: data?.currency?.name || 'Нет данных' },
    { label: 'Способ получения денег', value: data?.disbursementMethod || 'Нет данных' },
    { label: 'Цель кредита', value: data?.loanPurpose?.name || 'Нет данных' },
    { label: 'Тип займа', value: data?.loanType || 'Нет данных' },
    { label: 'Процентная ставка', value: data?.interestRate?.toString() || 'Нет данных' },
    { label: 'Количество траншей', value: data?.numberOfTranches?.toString() || 'Нет данных' },
    { label: 'Ступень займа', value: data?.loanStage?.toString()?.thousandSeparator() || 'Нет данных' },
    {
      label: 'Длительность периода между погашениями',
      value: data?.paymentIntervalDays?.toString()?.thousandSeparator() || 'Нет данных'
    }
  ]
}
const loanRequestCheckboxData = () => {
  return [
    { label: 'Переносить проценты по пролонгированным контрактам на последний транш  ', checked: false },
    { label: 'Оригиналы документов получены', checked: false }
  ]
}

const loanProductData = data => {
  if (!data) return []

  const creditField = data?.[0]?.creditField || {}

  return [
    {
      label: 'Отсроченный льготный период (в днях)',
      value: creditField?.interestLgotPeriod?.toString() || 'Нет данных'
    },
    {
      label: 'Процентная ставка для отсроченного льготного периода',
      value: creditField?.interestLgotRate?.toString() || 'Нет данных'
    },
    {
      label: 'Беспроцентный льготный период (в днях)',
      value: creditField?.interestGracePeriod?.toString() || 'Нет данных'
    },
    { label: 'Процентная ставка при просрочке', value: creditField?.delinquencyIntRate?.toString() || 'Нет данных' },
    { label: 'Метод расчета дат', value: creditField?.dateCalcMethodId?.toString() || 'Нет данных' },
    { label: 'Тип процентной ставки', value: creditField?.interestRateTypeId?.toString() || 'Нет данных' },
    { label: 'Метод расчета процентов', value: creditField?.interestCalcMethodId?.toString() || 'Нет данных' },
    { label: 'Метод начисления процентов', value: creditField?.interestChargeMethodId?.toString() || 'Нет данных' },
    {
      label: 'Метод распределения основной суммы',
      value: creditField?.principalDistribMethodId?.toString() || 'Нет данных'
    },
    {
      label: 'Метод зачета предоплаты',
      value: creditField?.forepaymentConsiderationMethodId?.toString() || 'Нет данных'
    },
    {
      label: 'Порядок погашения',
      value: creditField?.repaymentSequenceId?.toString() || 'Нет данных'
    },
    { label: 'Тип кредитной линии', value: creditField?.creditLineId?.toString() || 'Нет данных' },
    {
      label: 'Период обязательного начисления процентов',
      value: creditField?.mandatoryChargePeriod?.toString() || 'Нет данных'
    },
    {
      label: 'Кол-во дней начисления процентов по окончанию графика',
      value: creditField?.qtyDaysStopPenaltyOnClose?.toString() || 'Нет данных'
    },
    { label: 'Срок пролонгации', value: creditField?.prolongationPeriod?.toString() || 'Нет данных' },
    {
      label: 'Кол-во дней после окончания графика до остановки штрафов',
      value: creditField?.qtyDaysStopPenaltyOnClose?.toString() || 'Нет данных'
    },
    {
      label: 'Кол-во дней до перехода на ставку при просрочке',
      value: creditField?.delinqIntRateDelay?.toString() || 'Нет данных'
    },
    { label: 'Вид начисления штрафа', value: creditField?.penaltyTypeId?.toString() || 'Нет данных' },
    { label: 'Штраф за опоздание (фикс.сумма)', value: creditField?.fixedDelayPenalty?.toString() || 'Нет данных' },
    {
      label: 'День просрочки для начисления штрафа за опоздание',
      value: creditField?.delayPenaltyDay?.toString() || 'Нет данных'
    }
  ]
}

const loanProductCheckboxData = data => {
  if (!data) return []
  const creditField = data?.[0]?.creditField || {}

  const isChecked = value => value === 'Y'

  return [
    { label: 'Досрочная пролонгация', checked: isChecked(creditField.isEarlyProlongationFromCurrentDate) },
    {
      label: 'Полное смещение графика от фактической даты выдачи',
      checked: isChecked(creditField.isShiftFirstRepaymentDate)
    },
    { label: 'Перерасчет графика в дату планового платежа', checked: isChecked(creditField.isScheduleRecalcEnabled) },
    { label: 'Первые выходные штрафы не начислять', checked: isChecked(creditField.isFirstWeekendWithoutPenalty) },
    { label: 'Контроль краткосрочности займа', checked: isChecked(creditField.isShortTermControl) },
    { label: 'Рассчитывать проценты от суммы в контракте', checked: isChecked(creditField.isInterestOnLoanAmount) },
    { label: 'Не переносить с праздников и выходных', checked: isChecked(creditField.isAllowHolidaysPayment) },
    { label: 'Начислять проценты на просроченную ОС', checked: isChecked(creditField.isCalcInterestOnDelinqBalance) },
    {
      label: 'Начислять проценты на просроченную ОС только по ставке при просрочке',
      checked: isChecked(creditField.isCalcIntOnDelinqBalanceOnlyAtDelinqIntRate)
    },
    { label: 'Начислять проценты в день выдачи контракта', checked: isChecked(creditField.isCalcIntOnIssueDate) },
    { label: 'Возможно погашение до срока при автоакцепте', checked: isChecked(creditField.isAllowPrepayment) },
    { label: 'Штраф по календарным дням', checked: isChecked(creditField.isCalendarDaysPenalty) },
    { label: 'Останавливать штрафы после окончания графика', checked: isChecked(creditField.isStopPenaltyOnClose) },
    {
      label: 'Продолжать применять ставку при просрочке после выхода из просрочки',
      checked: isChecked(creditField.isKeepUsingDelinqIntRate)
    },
    {
      label: 'Использовать процентную ставку при просрочке для расчета ПСК',
      checked: isChecked(creditField.isUseDelinqIntRateForPsk)
    },
    { label: 'Создавать новый график при пролонгации', checked: isChecked(creditField.isProlongationOnNewSchedule) },
    {
      label: 'Возвращение к регулярной процентной ставке со следующего транша после погашения просрочки',
      checked: isChecked(creditField.isUseDelinqIntRateTillNextTranche)
    }
  ]
}

export const ContractTab = memo(() => {
  const {
    contractStore: { loanApplicationData, creditProducts },
    contractStoreFunc: { getCreditProducts }
  } = useContractStore()

  useEffect(() => {
    if (loanApplicationData?.creditProduct?.name) {
      getCreditProducts(loanApplicationData?.creditProduct?.name)
    }
  }, [loanApplicationData?.creditProduct?.name])

  return (
    <>
      <CustomAccordion
        title="Заявка"
        data={loanRequestData(loanApplicationData)}
        checkboxData={loanRequestCheckboxData}
      />

      {/* <CustomAccordion
        title="Кредитный продукт"
        data={loanProductData(creditProducts)}
        checkboxData={loanProductCheckboxData(creditProducts)}
        open={true}
      /> */}
    </>
  )
})
